import type { ArithExperimentDef, ExperimentKey } from '../types';
import { mountFractionFoundry } from './fraction-foundry';
import { experiment as percentGridExperiment } from './percent-grid';
import { experiment as primeFactorTreeExperiment } from './prime-factor-tree';
import { mountModularClock } from './modular-clock';
import { mountNumberLineSurgeon } from './number-line-surgeon';
import { mountPlaceValueBlocks } from './place-value-blocks';
import { experiment as ratioMixerExperiment } from './ratio-mixer';
import { mountPowerTower } from './power-tower';

export const EXPERIMENTS: Record<ExperimentKey, ArithExperimentDef> = {
  'fraction-foundry': {
    labelKey: 'experiment.fraction-foundry.label',
    params: [],
    mount: mountFractionFoundry,
  },
  'percent-grid': percentGridExperiment,
  'prime-factor-tree': primeFactorTreeExperiment,
  'modular-clock': {
    labelKey: 'experiment.modular-clock.label',
    params: [],
    mount: mountModularClock,
  },
  'number-line-surgeon': {
    labelKey: 'experiment.number-line-surgeon.label',
    params: [],
    mount: mountNumberLineSurgeon,
  },
  'place-value-blocks': {
    labelKey: 'experiment.place-value-blocks.label',
    params: [],
    mount: mountPlaceValueBlocks,
  },
  'ratio-mixer': ratioMixerExperiment,
  'power-tower': {
    labelKey: 'experiment.power-tower.label',
    params: [],
    mount: mountPowerTower,
  },
};

export const EXPERIMENT_ORDER: ExperimentKey[] = [
  'fraction-foundry',
  'percent-grid',
  'prime-factor-tree',
  'modular-clock',
  'number-line-surgeon',
  'place-value-blocks',
  'ratio-mixer',
  'power-tower',
];
